import { render, staticRenderFns } from "./GKCheckbox.vue?vue&type=template&id=392bb35e&scoped=true&"
import script from "./GKCheckbox.vue?vue&type=script&lang=js&"
export * from "./GKCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./GKCheckbox.vue?vue&type=style&index=0&id=392bb35e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392bb35e",
  null
  
)

export default component.exports